<template>
  <b-table
    :data="data"
    :loading="loading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column field="uf" label="Estado" width="10%"
        ><span style="font-weight: bold;">{{
          props.row.state.code
        }}</span></b-table-column
      >
      <b-table-column field="value" label="Valor" width="80%">{{
        props.row.value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
      }}</b-table-column>
      <b-table-column label="Opções">
        <button
          @click="edit(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </button>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import CardShippingFeesService from '@/services/card-shipping-fee.service';
import ToastMixin from '@/mixins/ToastifyMixin';
import NumberMixin from '@/mixins/NumberMixin';

export default {
  name: 'card-shipping-fees-table',
  mixins: [ToastMixin, NumberMixin],
  data: () => {
    return {
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      CardShippingFeesService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;
          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Taxas.', 'error'))
        .finally(() => (this.loading = false));
    },
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
